@if (dropdownType === 'standardCode') {
  <div class="code-container">
    @if (categoryControl.value) {
      <span class="code-title">{{ codeTitle }}</span>
      <mat-form-field class="dropdown-container">
        <mat-select
          placeholder="{{ codePlaceholder }}"
          [value]="selectedCode"
          (selectionChange)="onCodeChange($event)"
        >
          @for (code of dropdownValues; track code) {
            <mat-option [value]="code" [disabled]="isCodeUsed(code)">{{
              code
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button
        class="clear-button"
        mat-icon-button
        (click)="clearCodeSelection()"
      >
        <mat-icon>close</mat-icon>
      </button>
    } @else {
      <span class="code-title-disabled">{{ codeTitle }}</span>
      <mat-form-field class="dropdown-container">
        <mat-select placeholder="{{ codePlaceholder }}" [disabled]="true">
          @for (code of dropdownValues; track code) {
            <mat-option [value]="code">{{ code }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
}
